<template>
  <LayoutsDefault
    class="main-content"
    :white-logo="true"
    :product-name="$t('support')"
    :product-path="localePath('/support')"
  >
    <slot />
  </LayoutsDefault>
</template>
<script lang="ts" setup>
// -------------------------------------------
// Hooks
// -------------------------------------------
const localePath = useLocalePath();
</script>
